import getImagePath from "@Utils/getImagePath";
import config from "config/index";

const chinaSocialMediaData = [
  {
    name: "ThanksRED",
    id: "thanks_red",
    link: "https://www.xiaohongshu.com/user/profile/619c029e0000000010005b59",
    icon: getImagePath(`${config.IMAGE_STATIC_URL}/images/thanksred.svg`),
  },
  {
    name: "Douyin",
    id: "douyin",
    link: "https://www.douyin.com/user/MS4wLjABAAAAEw3NiIWRgncsm1MGDtCDQCf2xA1kO8iKs7j17qtaPDQ",
    icon: getImagePath(`${config.IMAGE_STATIC_URL}/images/tiktok.svg`),
  },
  {
    name: "Baijiahao",
    id: "baijiahao",
    link: "https://author.baidu.com/home/1833532493200803",
    icon: getImagePath(`${config.IMAGE_STATIC_URL}/images/baidu-baijiahao-icon-filled-256.webp`),
  },
  {
    name: "We chat OA",
    id: "We chat OA",
    link: "http://weixin.qq.com/r/mp/lhMQCHDEPC1DrTRr90aE",
    icon: getImagePath(`${config.IMAGE_STATIC_URL}/images/wechat-oa-logo.png`),
  },
];

export default chinaSocialMediaData;
